import {inject, injectable} from 'inversify';

import type {MetricApiModel} from '../../../../api/metrics/types';
import type {IApiDataMapper} from '../../../../core/ports/types';

import {DateTimeMapperJrpc} from '../../Date/mappers/DateTime.mapper.jrpc';
import {MetricFactory} from '../Metric.factory';
import {MetricModel} from '../Metric.model';

@injectable()
export class MetricMapperJrpc
  implements
    IApiDataMapper<MetricMapperJrpc.ApiData, MetricModel.Props, MetricModel>
{
  constructor(
    @inject(MetricFactory)
    private readonly factory: MetricFactory,
    @inject(DateTimeMapperJrpc)
    private readonly dateMapper: DateTimeMapperJrpc,
  ) {}

  mapDataToModel(apiData: MetricMapperJrpc.ApiData): MetricModel {
    return this.factory.create(this.mapDataToProps(apiData));
  }

  mapDataToProps({
    _id,
    created,
    date,
    updated,
    weight,
  }: MetricMapperJrpc.ApiData): MetricModel.Props {
    return {
      created: this.dateMapper.mapToModel(created),
      date: this.dateMapper.mapToModel(date),
      id: _id,
      updated: this.dateMapper.mapToModel(updated),
      weight,
    };
  }
}

export namespace MetricMapperJrpc {
  export type ApiData = MetricApiModel;
}
